"use client";

import { FileCheck, Video, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VerificationFeature() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const features = [{
    icon: FileCheck,
    title: "Downloadable Land Titles",
    description: "Don't trust our word. Download the official Lands Commission Search Report directly from our server. Updated every 30 days."
  }, {
    icon: Video,
    title: "24/7 Live Site Cams",
    description: "Login to the secure portal and control the 4G site camera. Zoom in on the foundation. Verify the workforce. See your money at work, live."
  }, {
    icon: MapPin,
    title: "GPS-Stamped Progress Logs",
    description: "Every site photo is cryptographically stamped with GPS coordinates and timestamps. Impossible to fake. Impossible to backdate."
  }];
  return <section id="verification-feature" ref={containerRef} className="bg-light-background py-20 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-primary mb-4">
            The Glass House Protocol
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Trust through transparency—every investment backed by verifiable data
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className={`group relative overflow-hidden border border-border bg-secondary-light transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
                <CardContent className="flex flex-col items-center text-center p-8">
                  <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                    <Icon className="h-8 w-8 text-primary" />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-foreground mb-3 relative inline-block">
                    {feature.title}
                    <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}